import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Typography } from '~/components/elements/Typography'
import { type CustomerStrategyType } from '~/gql/graphql'

import { type InputValues } from '../utils'

export type StrategyTypeNoteProps = {
  index: number
}

export const StrategyTypeNote = ({ index }: StrategyTypeNoteProps) => {
  const { t } = useTranslation()
  const { watch } = useFormContext<InputValues>()
  const strategyType = watch(`strategies.${index}.strategyType`)

  const noteMap: Record<CustomerStrategyType, string> = React.useMemo(
    () => ({
      new: t('please_select_the_growth_paths'),
      existing: t('please_select_the_growth_paths_1'),
      free: t('please_select_the_growth_paths_2'),
    }),
    [t],
  )

  return <Typography variant="normal">{noteMap[strategyType]}</Typography>
}
